import React from 'react';
import styles from './InternalAdminTool.module.scss';

interface InvalidOrganisationProps {
  logoSrc: string;
}

const InvalidOrganisation: React.FC<InvalidOrganisationProps> = ({ logoSrc }) => {
  return (
    <div className={styles.container}>
      <img 
        src={logoSrc} 
        alt="ACC Logo" 
        className={styles.grayscaleLogo} 
      />
      <div className={styles.message}>
        Please return to Access Workspace Administrator to untick (& Update Organisation) then tick (& Update Organisation) the Care Compliance product.<br /><br />
        This will trigger the web hooks.
      </div>
    </div>
  );
};

export default InvalidOrganisation;
